(function(angular){
	'use strict';
	
	var mediaGalleryPreviewObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			investorUpdateId: '<',
			mediaItems: '<'
		},
		controller: [
			'$rootScope',
			MediaGalleryPreviewFunction
		],
		controllerAs: 'mediaGalleryPreview'
	};
	
	angular
		.module('mediaGalleryModule')
		.component('mediaGalleryPreview', mediaGalleryPreviewObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/modal/media-gallery-preview.html';
	}
	
	function MediaGalleryPreviewFunction(
		$rootScope
	){
		var mediaGalleryPreview = this;
		var imagesLoaded = false;
		var indexToPosition = {
			0: {
				'top': '0',
				'left': '0'
			},
			1: {
				'top': '0',
				'right': '0'
			},
			2: {
				'bottom': '0'
			},
			3: {
				'bottom': '0'
			}
		};

		var numberOfItemsToStyle = {
			0: {
				1: {
					height: '100%',
					width: '100%'
				},
				2: {
					height: '100%',
					width: 'calc(50% - 1px)'
				},
				3: {
					height: '100%',
					width: 'calc(50% - 1px)'
				},
				4: {
					height: 'calc(50% - 1px)',
					width: 'calc(50% - 1px)'
				}
			},
			1: {
				2: {
					height: '100%',
					width: 'calc(50% - 1px)'
				},
				3: {
					height: 'calc(50% - 1px)',
					width: 'calc(50% - 1px)'
				},
				4: {
					height: 'calc(50% - 1px)',
					width: 'calc(50% - 1px)'
				}
			},
			2: {
				3: {
					right: '0',
					height: 'calc(50% - 1px)',
					width: 'calc(50% - 1px)'
				},
				4: {
					left: '0',
					height: 'calc(50% - 1px)',
					width: 'calc(50% - 1px)'
				}
			},
			3: {
				4: {
					right: '0',
					height: 'calc(50% - 1px)',
					width: 'calc(50% - 1px)'
				}
			}
		};

		mediaGalleryPreview.getStyle = function(index) {
			var computedStyle = {
			};

			var maxShow = mediaGalleryPreview.mediaItems.length >= 4 ? 4 : mediaGalleryPreview.mediaItems.length;

			angular.extend(computedStyle, indexToPosition[index]);
			angular.extend(computedStyle, numberOfItemsToStyle[index][maxShow]);

			return computedStyle;
		};

		mediaGalleryPreview.openModal = function(index) {
			$rootScope.ModalFactory.openMediaGallery({
				investorUpdateId: mediaGalleryPreview.investorUpdateId,
				mediaItems: mediaGalleryPreview.mediaItems,
				selectedIndex: index
			});
		};
	}
})(window.angular);